import React, { useContext } from 'react';
import classNames from 'classnames';

import { StoreContext } from '../../context/store-context';

import Badge from '../Badge';
import PlainButton from '../PlainButton';

import { useLocalStorage } from '../../utils/hooks';

import renderIcon from '../../utils/renderIcon';

const ns = `cart-button`;

const CartButton = () => {
	const {
		loading,
		checkout,
		classCheckout,
		isCartFlyoutOpen,
		cartFlyoutOpen,
		cartFlyoutClose,
	} = useContext(StoreContext);

	const { value: draftOrdersIds } = useLocalStorage('draftOrdersIds', []);

	const quantity = checkout.totalQuantity + classCheckout.totalQuantity + draftOrdersIds.length;

	const handleCartClick = () => {
		return isCartFlyoutOpen ? cartFlyoutClose(checkout) : cartFlyoutOpen(checkout);
	};

	const rootClassnames = classNames({
		[`${ ns }`]: true,
	});

	return (
		<PlainButton
			aria-label={`Shopping Cart with ${ quantity } items`}
			onClick={handleCartClick}
			className={rootClassnames}
			disabled={loading}
		>
			{renderIcon('cart')}
			{quantity > 0 && <Badge>{quantity}</Badge>}
		</PlainButton>
	);
};

export default CartButton;
